import { defineStore } from 'pinia';
import UserApi from '@/api/user-api';
import { showToast } from '@/helpers/toast-handler';
import { addFullNameToUserArray } from '@/helpers/json-formatter';

export const useUserStore = defineStore('user', {
    state: () => ({
        loading: false,
        user: {},
        users: [],
        userMfa: null,
        totalUserRecords: null,
    }),
    actions: {
        async fetchAllUsers(company_id, params) {
            try {
                this.loading = true;
                const response = await UserApi.getAllUsers(company_id, params);
                this.users = addFullNameToUserArray(response.data.data);
                this.totalUserRecords = response.data.total;
            } catch (error) {
                throw new Error('Failed to fetch users');
            } finally {
                this.loading = false;
            }
        },

        async fetchUserDetails(userId, company_id) {
            try {
                const response = await UserApi.getUserById(userId, company_id);
                this.user = response.data;
                return response.data;
            } catch (error) {
                throw new Error('Failed to fetch user details');
            }
        },

        async createUser(body) {
            try {
                const response = await UserApi.createUser(body);
                this.user = response.data;
                if (response.statusCode == '201') showToast(response, 'User created successfully');
                return response.data;
            } catch (error) {
                showToast({}, error?.data?.message ?? 'Failed to create a new user');
            }
        },

        async checkUserMFA(userId, company_id) {
            try {
                const response = await UserApi.checkUserMfa(userId, company_id);
                this.userMfa = response.data;
                return response.data;
            } catch (error) {
                throw new Error('Failed to check mfa for user');
            }
        },

        async updateUserDetails(userId, body) {
            try {
                const response = await UserApi.updateUserDetails(userId, body);
                this.user = response.data;
                if (response.statusCode == '200') showToast(response, 'User details updated successfully');
                return response.data;
            } catch (error) {
                showToast(error.response, 'Failed to update user details');
            }
        },
        setUsers(users) {
            this.loading = true;
            setTimeout(async () => {
                this.users = users;
            }, Math.random() * 1000 + 250);
            this.loading = false;
        },
    },
});
